import React from 'react'
import { Routes, Route, Link } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'

// Pages
import Home from './pages/Home'
import About from './pages/About'
import AppPage from './pages/AppPage'
import Contact from './pages/Contact'
import ServiceDetail from './pages/ServiceDetail'
import BilerTilSalg from './pages/BilerTilSalg'
import Medarbejdere from './pages/Medarbejdere'
import Galleri from './pages/Galleri'
import { NotFoundPage, ForbiddenPage } from './pages/ErrorPages'

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-brand-dark text-white">
      <ScrollToTop />
      
      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/frejlev-auto-dit-lokale-autovaerksted" element={<About />} />
          <Route path="/app" element={<AppPage />} />
          <Route path="/kontakt-frejlev-auto" element={<Contact />} />
          <Route path="/biler-til-salg" element={<BilerTilSalg />} />
          <Route path="/medarbejdere" element={<Medarbejdere />} />
          <Route path="/galleri" element={<Galleri />} />
          <Route path="/403" element={<ForbiddenPage />} />
          
          {/* Dynamic Service Pages */}
          <Route path="/:slug" element={<ServiceDetail />} />
          
          {/* Fallback 404 Route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default App
